export const latestVersionMetadata = {
  '@apollo/server': {
    latest: '4.12.0',
    byMajor: {
      2: {
        latest: '2.26.2',
      },
      3: {
        latest: '3.13.0',
      },
      4: {
        latest: '4.12.0',
      },
    },
  },
  'apollo-server-core': {
    latest: '4.12.0',
    byMajor: {
      2: {
        latest: '2.26.2',
      },
      3: {
        latest: '3.13.0',
      },
      4: {
        latest: '4.12.0',
      },
    },
  },
  'apollo-router': {
    latest: '2.1.2',
    byMajor: {
      0: {
        latest: '0.1.0',
      },
      1: {
        latest: '1.61.3',
      },
      2: {
        latest: '2.1.2',
      },
    },
  },
};
